import { jsx as g } from "react/jsx-runtime";
import { useMemo as u, useEffect as m } from "react";
import { useCommittedCallback as a } from "../../useCommittedCallback/index.js";
import { assertScope as I, assertActionId as v } from "../system/assertions.js";
import { GLOBAL_SCOPE as l } from "../system/constants.js";
import { getActiveBindingsForScope as A } from "../system/matching.js";
import "../key/constants.js";
import { InputSystemContext as b, useInternalInputSystem as i } from "./context.js";
import { useActionRegistry as B } from "./useActionRegistry.js";
import { useKeyboardListener as P } from "./useKeyboardListener.js";
import { useScopeStack as y } from "./useScopeStack.js";
function x(e) {
  if (!("compiledBindings" in e) || typeof e.compiledBindings != "object")
    throw new Error("InputSystemProvider requires a system created by defineInputSystem(...).");
}
function G({ system: e, onAction: t, onError: r, children: n }) {
  I(e, l, "InputSystemProvider"), x(e);
  const { effectiveScope: o, effectiveScopeRef: f, registerScope: c } = y(e), { getAction: S, registerAction: s } = B(e);
  P({
    system: e,
    effectiveScopeRef: f,
    getAction: S,
    onAction: t,
    onError: r
  });
  const p = u(() => A(e, o), [o, e]), d = u(
    () => ({
      scope: o,
      scopes: e.scopes,
      bindings: e.bindings,
      activeBindings: p,
      registerAction: s,
      registerScope: c
    }),
    [p, o, s, c, e]
  );
  return /* @__PURE__ */ g(b.Provider, { value: d, children: n });
}
function K() {
  const { activeBindings: e, bindings: t, scope: r, scopes: n } = i();
  return { activeBindings: e, bindings: t, scope: r, scopes: n };
}
function M(e, t) {
  const r = i(), { registerAction: n } = r;
  v(r, e, "InputSystemProvider.registerAction");
  const o = a(t);
  m(() => n(e, o), [o, e, n]);
}
function V(e) {
  const { registerScope: t } = i();
  m(() => t(e), [e, t]);
}
export {
  G as InputSystemProvider,
  K as useInputSystem,
  M as useRegisterAction,
  V as useRegisterScope
};
